module.exports = __webpack_public_path__ + "img/01.34622ef7.jpg";